import { forwardRef } from "react";

interface Props {
  ariaLabel?: string;
  children?: React.ReactNode;
}

const Nav = forwardRef<HTMLElement, Props>(function Nav(
  { ariaLabel, children },
  ref
) {
  return (
    <nav
      ref={ref}
      className="site-header__nav"
      aria-label={ariaLabel || "Main Navigation"}
    >
      {children}
    </nav>
  );
});

export default Nav;
